import { Directive, Inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MediaDirective } from './media.directive';
import { Subscription } from 'rxjs';
import { MediaService as MediaUploadService } from './media.service';
import { AutoUnsubscribe } from '../../utils/misc/auto-unsubscribe';
import { ToastrService } from '../../shared/services/utilities/toastr.service';
import { User } from '@adeo/ngx-kozikaza-api';
import { MediaService } from '@adeo/ngx-kozikaza-api/media';
import { UserService as LegacyUserService } from '../../shared/services/features/user';
import { map, switchMap } from 'rxjs/operators';
import { ModalService } from '../../utils/modals/modals.service';

@Directive({
  // tslint:disable-next-line
  selector: '[media-avatar]'
})
@AutoUnsubscribe([])
export class MediaAvatarDirective extends MediaDirective implements OnDestroy, OnChanges {
  mediaType = 'user_avatar';
  subscriptionUserUpdate: Subscription;
  subscriptionUser: Subscription;
  @Input() currentUser: User;

  constructor(
    @Inject(ModalService) modalService: ModalService,
    private toastrService: ToastrService,
    private mediaUploadService: MediaUploadService,
    private mediaService: MediaService,
    protected legacyUserService: LegacyUserService
  ) {
    super(modalService);
    this.title = $localize`:@@user.avatar.modal.title:Choose your profile picture`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'currentUser' && this.currentUser) {
        this.kaza = (this.currentUser.activeKaza) ? this.currentUser.activeKaza : this.kaza;
      }
    }
  }

  ngOnDestroy() {
    // Empty method. Don't remove. Essential for @AutoUnsubscribe to run.
  }

  onMediaSaved(file: any): void {
    this.subscriptionUserUpdate = this.legacyUserService.update(this.currentUser['@id'], { avatar : file.formated}).pipe(
        switchMap((user) => {
          return this.mediaService.getMedia(user.avatar).pipe(
              map((avatar) => {
                user.avatar = avatar;
                return user;
              })
          );
        })
    ).subscribe(
      (data) => {
        this.afterSaved.emit(data.avatar);
        this.modal.close();
        this.mediaUploadService.removeAllMedia();
        this.toastrService.info($localize`:@@toast.info_saved:Your information has been saved`);
      },
      (err) => {
        this.toastrService.error($localize`:@@toast.could_not_save_avatar:Can not save the avatar`);
      }
    );
  }
}
